import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { fetchAllData, fetchQuizAnswerKey } from "./quiz3Utils";

// PQ-02 — in đáp án của 1 đề CỐ ĐỊNH ra giấy cho GV chấm (chỉ người tạo đề
// mới xem được, xem GET /api/quizzes/:id/answer-key). Khác Quiz3PrintSheet
// (in đề + phiếu trả lời trống cho học sinh) — trang này in đáp án ĐÚNG.
const Quiz3PrintAnswerKey = () => {
  const { quizId } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [quiz, setQuiz] = useState(null);
  const [rows, setRows] = useState([]); // [{ number, letter }]

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const data = await fetchAllData();
        const q = (data.quizzes || {})[quizId];
        if (!q) { if (!cancelled) { setError("Không tìm thấy đề thi này."); setLoading(false); } return; }
        if (q.type !== "fixed") {
          if (!cancelled) {
            setError("Chỉ in được đáp án với đề CỐ ĐỊNH (fixed) — đề tổng hợp có thứ tự câu ngẫu nhiên mỗi lần nên không có đáp án cố định để in.");
            setLoading(false);
          }
          return;
        }
        const ids = q.questionIds || [];
        const questions = ids.map((id) => ((data.questions || {})[id] ? { id, ...data.questions[id] } : null));
        const correctAnswers = await fetchQuizAnswerKey(quizId);
        const builtRows = questions.map((qq, i) => {
          if (!qq) return { number: i + 1, letter: "?" };
          const idx = (qq.options || []).findIndex((o) => o.id === correctAnswers[qq.id]);
          return { number: i + 1, letter: idx >= 0 ? String.fromCharCode(65 + idx) : "?" };
        });
        if (!cancelled) {
          setQuiz({ id: quizId, ...q });
          setRows(builtRows);
          setLoading(false);
        }
      } catch (err) {
        if (!cancelled) { setError(err.message || "Có lỗi khi tải đáp án."); setLoading(false); }
      }
    })();
    return () => { cancelled = true; };
  }, [quizId]);

  if (loading) return <div style={pageWrap}>Đang tải đáp án...</div>;
  if (error) {
    return (
      <div style={pageWrap}>
        <p style={{ color: "#dc2626" }}>{error}</p>
        <Link to="/quiz3/take">← Quay lại chọn đề</Link>
      </div>
    );
  }

  return (
    <div>
      <style>{PRINT_CSS}</style>

      <div className="no-print" style={toolbarStyle}>
        <button onClick={() => window.print()} style={primaryBtnStyle}>🖨 In đáp án</button>
        <Link to="/quiz3/take" style={secondaryBtnStyle}>← Quay lại chọn đề</Link>
      </div>

      <div id="quiz3-answerkey-print-area">
        <div className={`quiz3-answerkey-page${rows.length > 100 ? " quiz3-answerkey-compact" : ""}`}>
          <h2 style={{ textAlign: "center", margin: "0 0 4px" }}>ĐÁP ÁN</h2>
          <p style={{ textAlign: "center", color: "#6b7280", margin: "0 0 20px" }}>{quiz.title}</p>
          <div className="quiz3-answerkey-grid">
            {rows.map((r) => (
              <div key={r.number} className="quiz3-answerkey-cell">
                <span className="quiz3-answerkey-num">Câu {r.number}:</span>
                <span className="quiz3-answerkey-letter">{r.letter}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

const PRINT_CSS = `
@page { size: A4; margin: 14mm; }
.quiz3-answerkey-page { max-width: 800px; margin: 0 auto; background: #fff; }
.quiz3-answerkey-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 8px 16px;
}
.quiz3-answerkey-cell {
  display: flex;
  justify-content: space-between;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 4px 10px;
  font-size: 14px;
}
.quiz3-answerkey-num { color: #374151; }
.quiz3-answerkey-compact .quiz3-answerkey-grid { gap: 3px 10px; }
.quiz3-answerkey-compact .quiz3-answerkey-cell { padding: 1px 8px; font-size: 12px; border-radius: 4px; }
.quiz3-answerkey-letter { font-weight: 700; color: #111827; }
@media screen {
  #quiz3-answerkey-print-area { background: #e5e7eb; padding: 20px 0; min-height: 100vh; }
  .quiz3-answerkey-page { box-shadow: 0 1px 4px rgba(0,0,0,0.2); padding: 24px; }
}
@media print {
  body * { visibility: hidden; }
  #quiz3-answerkey-print-area, #quiz3-answerkey-print-area * { visibility: visible; }
  #quiz3-answerkey-print-area { position: absolute; left: 0; top: 0; width: 100%; background: #fff; padding: 0; }
  .no-print { display: none !important; }
  .quiz3-answerkey-page { box-shadow: none; margin: 0; padding: 0; }
}
`;

const pageWrap = { padding: 24, maxWidth: 800, margin: "0 auto" };
const toolbarStyle = { padding: "16px 24px", maxWidth: 800, margin: "0 auto" };
const primaryBtnStyle = {
  padding: "8px 18px", background: "#2563eb", color: "#fff", border: "none",
  borderRadius: 8, cursor: "pointer", fontWeight: 600, marginRight: 10,
};
const secondaryBtnStyle = {
  padding: "8px 18px", background: "#fff", color: "#374151", border: "1px solid #d1d5db",
  borderRadius: 8, cursor: "pointer", textDecoration: "none", fontWeight: 600, display: "inline-block",
};

export default Quiz3PrintAnswerKey;
